export default class RegistrationForm {
  constructor(c) {
    // Variables
    this.$form = c;
    this.formAction = this.$form.getAttribute("action");
    this.formMethod = this.$form.getAttribute("method");
    this.$wrapper = c.parentNode;
    this.$submitBtn = c.querySelector('button[type="submit"]');
    this.$sendLabel = this.$submitBtn.querySelector(".form__send-label");
    this.$stepper = document.querySelector(".registration-steps");
    this.$steps = this.$stepper.querySelectorAll(".registration-steps__step");
    this.$prevStepBtn = document.querySelector(".form-navigation__prev");
    this.$nextStepBtn = document.querySelector(".form-navigation__next");
    this.currentStep = 1;
    this.$stepInput = this.$form.querySelector('input[name="step"]');
    this.$abortRegistrationBtn = document.querySelector(".page-header__back");
    this.$hasFormChange = false;

    // Events
    this.initSteps();
    this.handleSubmit();
    this.initSelectToggles();
    this.initSectionRadioToggles();
    this.handleAbortRegistration();

    this.formChangeLeaveHandler = function pageLeaveConfirm(e) {
      e.preventDefault();
      e.stopPropagation();

      return confirm('Möchten Sie die Anmeldung wirklich abbrechen?');
    };
  }

  initSteps() {
    this.$steps.forEach((step) => {
      // Activate first step
      let stepNumber = parseInt(step.attributes["data-step"].value);
      if (stepNumber == this.currentStep) {
        step.classList.add("active");
        let fieldset = this.$form.querySelector(
          `fieldset[data-step="${stepNumber}"]`
        );
        fieldset.classList.add("active");
      }

      // Add click event to each step
      // step.addEventListener("click", (e) => {
      //   e.preventDefault();
      //   this.goToStep(stepNumber);
      //   // console.log("direct step change disabled");
      // });
    });

    // Add click event to the next button
    this.$prevStepBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // If it is not the first step
      if (this.currentStep > 1) {
        this.goToStep(this.currentStep - 1);
      }
    });

    // Hide prev button on first step
    this.currentStep == 1
      ? this.$prevStepBtn.classList.add("hidden")
      : this.$prevStepBtn.classList.remove("hidden");

    // Add click event to the next button
    this.$nextStepBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.validateStep(this.currentStep)
        .then((stepIsValid) => {
          // console.log("Step is valid:", stepIsValid);
          if (stepIsValid) {
            this.goToStep(this.currentStep + 1, true);
          }
        })
        .catch((error) => {
          console.error("Catch error: ", error);
        });
    });
  }

  // Go to new step
  goToStep(stepNumber, completed = false) {
    // console.log("go to step", stepNumber);

    // Hide current fieldset
    let currentFieldset = this.$form.querySelector(
      `fieldset[data-step="${this.currentStep}"]`
    );
    currentFieldset.classList.remove("active");

    // Activate new fieldset
    let nextFieldset = this.$form.querySelector(
      `fieldset[data-step="${stepNumber}"]`
    );
    nextFieldset.classList.add("active");

    // Hide current step and mark completed
    let currentStep = this.$stepper.querySelector(
      `.registration-steps__step[data-step="${this.currentStep}"]`
    );
    currentStep.classList.remove("active");
    if (completed) currentStep.classList.add("completed");

    // Activate new step
    let nextStep = this.$stepper.querySelector(
      `.registration-steps__step[data-step="${stepNumber}"]`
    );
    nextStep.classList.add("active");

    // Update current step
    this.currentStep = stepNumber;

    // Set aria values on stepper
    this.$stepper.setAttribute("aria-valuenow", stepNumber);

    // Hide prev button on first step
    stepNumber == 1
      ? this.$prevStepBtn.classList.add("hidden")
      : this.$prevStepBtn.classList.remove("hidden");

    // Hide next button on last step
    stepNumber == this.$steps.length
      ? this.$nextStepBtn.classList.add("hidden")
      : this.$nextStepBtn.classList.remove("hidden");

    // Show submit button on last step
    stepNumber == this.$steps.length
      ? this.$submitBtn.classList.add("active")
      : this.$submitBtn.classList.remove("active");
  }

  // Get the data for the current fieldset
  getStepData(stepNumber, submit = false) {
    // Get current fieldset
    const currentFieldset = this.$form.querySelector(
      `fieldset[data-step="${stepNumber}"]`
    );

    // FormData object
    let formData = new FormData();

    // Collect all form data for fieldset
    Array.from(currentFieldset.elements).forEach((element) => {
      // Check if element has a name, is not disabled, and if it's a radio button, ensure it's checked
      if (
        element.name &&
        !element.disabled &&
        ((element.type !== "radio" && element.type !== "checkbox") ||
          (element.type === "radio" && element.checked) ||
          (element.type === "checkbox" && element.checked))
      ) {
        formData.append(element.name, element.value);
      }
    });

    // Add step value to form data
    formData.append("step", stepNumber);

    // Set indicator for next step or submit
    formData.append("isSubmit", submit);

    return formData;
  }

  // Modularize AJAX call for reusability and separation of concerns
  async sendFormData(formData) {
    try {
      const response = await fetch(this.formAction, {
        method: this.formMethod,
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(error);
    }
  }

  // Validate current step
  async validateStep(stepNumber) {
    // Get the fieldset data for the current step (do not submit yet)
    const formData = this.getStepData(stepNumber, false);

    try {
      const res = await this.sendFormData(formData);

      // Show Step errors and abort
      if (res.alert) {
        this.setErrors(res.alert);
        return false;
      }

      // Remove previous/old error messages
      this.removeErrors();

      // Continue to next step
      return true;
    } catch (error) {
      console.error("Step validation error:", error.message);
      return false;
    }
  }

  // Fetch form
  // --------------

  async handleSubmit() {
    // On submit button click
    this.$form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Disable submit button
      this.$submitBtn.disabled = true;
      
      // Get the fieldset data for the current step and submit
      const formData = this.getStepData(this.currentStep, true);

      this.$hasFormChange = false;
      window.removeEventListener('beforeunload', this.formChangeLeaveHandler);

      try {
        const res = await this.sendFormData(formData);
        
        // Enable submit button
        this.$submitBtn.disabled = false;

        // Show Step errors and abort
        if (res.alert) {
          // If res.alert is a string (error message), show fail message. Otherwise set errors on the form fields.
          if (typeof res.alert === "string") {
            this.showFail(res.alert);
          } else {
            this.setErrors(res.alert);
          }
          return false;
        }

        // Continue to next step
        this.showSuccess();
        return true;
      } catch (error) {
        console.error("Submission error:", error);
        this.showFail(error.message);
        return false;
      }
    });
  }

  // Go to success page
  // --------------

  showSuccess() {
    const successUrl = this.$form.getAttribute("data-success-url");
    window.location.href = successUrl;
  }

  // Show fail message
  // --------------

  showFail(error) {
    // Animate success message
    const $fail = document.querySelector(".form__fail");
    $fail.innerHTML = error;
    $fail.classList.add("active");
    gsap.from($fail, {
      opacity: 0,
      y: "+=16",
    });

    // But keep the button disabled
    this.$submitBtn.disabled = true;
  }

  // Take the server side validation and add errors to the input fields
  // --------------

  setErrors(v) {
    // Remove previous/old error messages
    this.removeErrors();

    // Set new errors
    for (const field in v) {
      // Add invalid class
      let input = this.$form.querySelector(`#${field}`);
      if (input) input.classList.add("invalid");

      // Create and append error message
      let errorMessage = document.createElement("span");
      errorMessage.innerText = v[field];
      errorMessage.classList.add("error-message");
      if (input) {
        input.parentNode.appendChild(errorMessage);
      }
    }
  }

  // Clean up old error messages
  // --------------

  removeErrors() {
    // Remove previous/old invalid classes
    let oldErrors = this.$form.querySelectorAll(".invalid");
    // console.log(oldErrors);
    oldErrors.forEach((oe) => {
      oe.classList.remove("invalid");
    });

    // Remove previous/old error messages
    let oldErrorMessages = this.$form.querySelectorAll(".error-message");
    oldErrorMessages.forEach((em) => {
      em.remove();
    });
  }

  // Select inputs revealing additional fields
  // --------------

  initSelectToggles() {
    // Select triggers
    const $selects = this.$form.querySelectorAll(".select-trigger");
    let visibleTargets = new Map();

    // Function to handle the display of target fields
    const handleDisplay = (select, option, shouldShow) => {
      const targetId = option.getAttribute("data-target");
      if (targetId) {
        const $targetField = this.$form.querySelector(
          `#${targetId}`
        ).parentNode;

        // Hide the previously visible target field for this select
        if (
          visibleTargets.get(select) &&
          visibleTargets.get(select) !== $targetField
        ) {
          visibleTargets.get(select).classList.add("field--hidden");
        }

        if (shouldShow) {
          $targetField.classList.remove("field--hidden");
          visibleTargets.set(select, $targetField); // Update the currently visible target for this select
        } else {
          $targetField.classList.add("field--hidden");
        }
      } else if (visibleTargets.get(select)) {
        // Hide the current visible target if the selected option doesn't have a target
        visibleTargets.get(select).classList.add("field--hidden");
        visibleTargets.set(select, null);
      }
    };

    // Loop through triggers and attach event listener
    $selects.forEach((select) => {
      select.addEventListener("change", () => {
        const $selectedOption = select.options[select.selectedIndex];
        const shouldShow = $selectedOption.hasAttribute("data-target");
        handleDisplay(select, $selectedOption, shouldShow);
      });
    });
  }

  // Radio buttons revealing toggeling sections
  // Also toggles required fields
  // --------------

  initSectionRadioToggles() {
    // Get all radio button elements
    const radioButtons = document.querySelectorAll(
      '.section-trigger input[type="radio"]'
    );

    // Map to associate radio buttons with their corresponding sections
    const radioToSectionMap = new Map();

    // Populate the map
    radioButtons.forEach((radio) => {
      const sectionId = radio.getAttribute("data-target"); // Assuming the radio buttons have a 'data-target' attribute
      const section = document.getElementById(sectionId);
      radioToSectionMap.set(radio, section);
    });

    // Show Section
    function showSection(section) {
      // Show it
      section.style.display = "flex";

      // Activate previously required fields
      const inputs = section.querySelectorAll("input, select, textarea");
      inputs.forEach((input) => {
        // Only set required if it was originally required
        if (input.getAttribute("data-was-required") === "true") {
          input.required = true;
        }
      });
    }

    // Hide Section
    function hideSection(section) {
      // Hide it
      section.style.display = "none";

      // Deactivate required fields
      const inputs = section.querySelectorAll("input, select, textarea");
      inputs.forEach((input) => {
        if (input.required) {
          input.setAttribute("data-was-required", "true"); // Remember that this field was required
          input.required = false;
        } else {
          input.removeAttribute("data-was-required"); // Ensure this attribute is only set for required fields
        }
      });
    }

    // Function to show/hide sections
    function toggleSections() {
      radioButtons.forEach((radio) => {
        const section = radioToSectionMap.get(radio);
        if (radio.checked && section) {
          showSection(section);
        } else if (section) {
          hideSection(section);
        }
      });
    }

    // Initialize the function to set the correct section on load
    toggleSections();

    // Add an event listener to each radio button to change the displayed section when the radio value changes
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", toggleSections);
    });
  }

  // Register page leave event
  handleAbortRegistration() {
    this.$form.addEventListener('change', () => {
      if (this.$hasFormChange === false) {
        this.$hasFormChange = true;
        window.addEventListener('beforeunload', this.formChangeLeaveHandler);
      }
    });
  }
}

